import { TextBoxRemoveIcon } from './TextBoxRemoveIcon';

/**
 * author: Michael Irigoyen
 * id B599787B-9A9F-45C1-AD76-45FB4B00EFFC
 * name text-box-remove
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/text-box-remove.svg
 * tags
 * - Files / Folders 
 */
export const FileDocumentBoxRemoveIcon = TextBoxRemoveIcon;
export default FileDocumentBoxRemoveIcon